import { Injectable, inject, effect, runInInjectionContext, Injector } from '@angular/core';
import { DepositService } from '../deposit/deposit.service';
import { RoomListService } from '../room-list/room-list.service';
import { ProfileService } from '../profile/profile.service';
import { ToastService } from '../toast/toast.service';

@Injectable({
  providedIn: 'root',
})
export class DepositWatcherService {
  private depositService = inject(DepositService);
  private roomListService = inject(RoomListService);
  private profileService = inject(ProfileService);
  private toastService = inject(ToastService);
  private injector = inject(Injector);

  blockToaster = false;

  async initialise(): Promise<void> {
    runInInjectionContext(this.injector, () => {
      effect(() => {
        const consumedDeposit = this.depositService.consumedDeposit()();
        if (consumedDeposit && consumedDeposit.roomId) {
          this.roomListService.addRoom(consumedDeposit.roomId, this.profileService.id);

          if (!this.blockToaster) {
            this.toastService.showGoToMatchToast(consumedDeposit.gameId, consumedDeposit.roomId);
          }
        }
      });
    });
  }
}
